import axios from 'axios';
import { storeToRefs } from 'pinia';
import { useAuthStore } from '@/store/modules/auth';
import FingerPrint from '@/utils/fp';
export async function getDeviceId() {
    const authStore = useAuthStore();
    const { deviceId } = storeToRefs(authStore);
    if (deviceId && deviceId.value) {
        return deviceId.value;
    }
    const { deviceId: fpDeviceId } = await FingerPrint.get();
    return fpDeviceId;
}
export async function fetchNewEncryptionKey() {
    const fetchFromEndpoint = async (baseURL) => {
        const deviceId = await getDeviceId();
        const api = axios.create({
            baseURL,
            headers: {
                'Content-Type': 'application/json',
                deviceid: deviceId,
            },
        });
        const response = await api.post('');
        return response?.data?.csrf || '';
    };
    try {
        const primaryURL = process.env.VUE_APP_AUTH_ENCRYPTION_ENDPOINT;
        return await fetchFromEndpoint(primaryURL);
    }
    catch (e) {
        console.error('Primary endpoint failed:', e);
        try {
            const backupURL = process.env.VUE_APP_ENCRYPTION_ENDPOINT;
            return await fetchFromEndpoint(backupURL);
        }
        catch (backupError) {
            console.error('Backup endpoint also failed:', backupError);
            return '';
        }
    }
}
export async function getEncryptionKey() {
    const csrfTokenInput = document.querySelector('input[name="_csrf"]');
    if (csrfTokenInput && csrfTokenInput.value) {
        return csrfTokenInput.value;
    }
    return fetchNewEncryptionKey();
}
export async function setNewEncryptionToken() {
    const encryptionKey = await fetchNewEncryptionKey();
    if (encryptionKey) {
        const csrfInput = document.getElementById('_csrf');
        if (csrfInput) {
            csrfInput.value = encryptionKey;
            return;
        }
        const tokenElement = document.createElement('input');
        tokenElement.type = 'hidden';
        tokenElement.name = '_csrf';
        tokenElement.id = '_csrf';
        tokenElement.value = encryptionKey;
        document.body.appendChild(tokenElement);
    }
}
